Revolution.Module.extend({
    NAME: "mde.compatibility", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/compatibility.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events

        this.initCompatibility();

    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },

    initCompatibility: function () {
        if ($('.js-compatibility').length) {
            $('.js-compatibility').each(function( index, elmt) {
                var $bkCompatibility = $(elmt);
                var default_compatibility = drupalSettings.compatibility;
                $bkCompatibility.find('.js-compat-item').each(function( index, item) {
                    if ($(this).data('value') == default_compatibility) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                });

                $bkCompatibility.find('.js-compat-btn').each(function( index, item) {
                    $(item).on('click', function() {
                        if (!$(this).closest('.js-compat-item').hasClass('active')) {
                            $bkCompatibility.find('.js-compat-item').removeClass('active');
                            $(this).closest('.js-compat-item').addClass('active');
                        }
                    })
                })
            });
        }
    }

});
